export default "__VITE_ASSET__EaPtkuh0__"